/**
 * header-scroll.js
 *
 * Hide the site header on scroll DOWN past a threshold; reveal it on scroll UP.
 * Always shown at the very top of the page (scrollY ≤ threshold).
 *
 * Rules:
 *  - Never hide while the cart drawer is open (user may be in the drawer flow).
 *  - Never hide while focus is inside the header (keyboard navigation).
 *  - Throttled with requestAnimationFrame — one rAF per scroll event batch.
 *  - prefers-reduced-motion: no transition; class is still toggled (instant show/hide).
 *    (The CSS transition is disabled via @media prefers-reduced-motion.)
 *
 * The .is-hidden class on .site-header triggers `transform: translateY(-100%)` in CSS.
 */

(function () {
  'use strict';

  const SCROLL_THRESHOLD = 80; // px — header stays visible below this point

  const headerEl = document.querySelector('.site-header');
  if (!headerEl) return;

  const cartDrawerEl = document.getElementById('cart-drawer');

  let lastScrollY = window.scrollY;
  let rafPending = false;

  function isCartOpen() {
    return cartDrawerEl && cartDrawerEl.classList.contains('is-open');
  }

  function isFocusInHeader() {
    return headerEl.contains(document.activeElement);
  }

  function update() {
    rafPending = false;

    const currentScrollY = window.scrollY;

    // Always show at the very top
    if (currentScrollY <= SCROLL_THRESHOLD) {
      headerEl.classList.remove('is-hidden');
      lastScrollY = currentScrollY;
      return;
    }

    // Don't hide if cart is open or focus is in the header
    if (isCartOpen() || isFocusInHeader()) {
      lastScrollY = currentScrollY;
      return;
    }

    const scrollingDown = currentScrollY > lastScrollY;

    if (scrollingDown) {
      headerEl.classList.add('is-hidden');
    } else {
      headerEl.classList.remove('is-hidden');
    }

    lastScrollY = currentScrollY;
  }

  window.addEventListener('scroll', function () {
    if (!rafPending) {
      rafPending = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });

  // Reveal header when focus enters it (keyboard nav)
  headerEl.addEventListener('focusin', function () {
    headerEl.classList.remove('is-hidden');
  });

  // Reveal header when cart closes (user may scroll next)
  if (cartDrawerEl) {
    const cartObserver = new MutationObserver(function () {
      if (!isCartOpen()) {
        headerEl.classList.remove('is-hidden');
      }
    });
    cartObserver.observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
  }

})();
